<template>
  <div class="card pointer color">
    <tooltip-btn :tooltip="option.tooltip" styles="position-absolute text-primary" style="right: 5px!important;"/>
    <img v-if="option.image" @click="selectColor(option)" :src="$filters.image(option.image, imageDimensions)" class="card-img-top">
    <div v-else @click="selectColor(option)" :class="{'card-image-top': option.image, 'card-background': !option.image}" :style="{background: option.value + ' !important' }" id="image"></div>
    <div @click="selectColor(option)" class="card-body">
      <label class="option-color__header" :for="'color-' + option.id">
        <span class="option-color__label">{{ option.name }}</span>
      </label>
    </div>
    <div class="card-footer">
      <div class="option-color__footer">
    <div class="form-check">
      <input
        @click="selectColor(option)"
      class="form-check-input"
      type="radio"
      :id="'color-' + option.id"
      :checked="option.selected">
      <label class="form-check-label" :for="'color-' + option.id">
        {{ option.label }}
      </label>
    </div>
  </div>
    </div>
  </div>
</template>
<script>
import { computed } from '@vue/reactivity'
import { useStore } from 'vuex'
import TooltipBtn from '@/pages/configurator/common/tooltipBtn.vue'
export default {
  name: 'ColorOption',
  components: {
    TooltipBtn
  },
  props: {
    option: {
      require: true,
      type: Object
    }
  },
  setup () {
    const store = useStore()
    const selectColor = (option) => store.dispatch('configurator/selectColor', option)
    const imageDimensions = computed(() => {
      let str = ''
      const width = 150
      const height = 100
      if (width) {
        str = Number.parseInt(width)
      }
      str += 'x'
      if (height) {
        str += Number.parseInt(height)
      }
      return str
    })
    return {
      imageDimensions,
      selectColor
    }
  }
}
</script>
<style scoped>
.card-body {
  padding: 0;
}
.color .card-img-top {
  height: 105px;
}
.color .card-background {
  height: 105px;
}
</style>
